import styled from "styled-components";

export const UserStatusWithdrawalLimitsNumbersStyled = styled.div`
    display: flex;
    flex-direction: column;
    color: var(--color-label-secondary);
    
    .amount {
        color: var(--color-label-primary);
    }
    
    .unlimited-amount {
        background: radial-gradient(84.17% 93.8% at 34.18% 6%, #C2C5FF 0%, #8AA2F6 75.67%, #695FE1 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
`;
